import URLConfig from '@Config/urls/url.config';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { Link, Outlet } from 'react-router-dom';

export default function BankCommission() {
  const tablinkStyle = { borderBottom: '2px solid lightblue', padding: '5px' };
  return (
    <>
      <CC.Box>
        <CC.Stack direction="row" spacing={2}>
          <Link
            style={tablinkStyle}
            to={URLConfig.ADMIN.BASE_SETTINGS.BANK.BANK_COMMISSION.COMMISSION}
          >
            Comission Banque
          </Link>
          <Link
            style={tablinkStyle}
            to={URLConfig.ADMIN.BASE_SETTINGS.BANK.BANK_COMMISSION.INTERCHANGE}
          >
            Commission Interchange
          </Link>
        </CC.Stack>

        <CC.Box pt="10">
          <Outlet />
        </CC.Box>
      </CC.Box>
    </>
  );
}
